import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'ramda';

import { submitResetPassword } from 'state/concepts/userProfile/resetPassword/actions';

import withLayout from 'views/layouts/withLayout';
import GuestLayout from 'views/layouts/Guest';

import ResetPasswordRequestComponent from 'views/resetPassword/ResetPasswordRequest';

class ResetPasswordRequest extends React.Component {
  static pageTitle = { id: 'pageTitle.resetPasswordRequest' };

  render = () => (
    <ResetPasswordRequestComponent
      {...this.props}
      redirectToLogin="/login"
    />
  );
}

const mapDispatchToProps = {
  onSubmit: submitResetPassword,
};

export { ResetPasswordRequest as ResetPasswordRequestContainer };
export default compose(
  withLayout(GuestLayout, { isGrey: false }),
  connect(null, mapDispatchToProps),
)(ResetPasswordRequest);
